import React, { Component } from 'react';
import Picea from './components/Picea';
import Infobox from './components/Infobox';
import Menu from './components/Menu';
// import Navigation from './components/Navigation';
import Bubbles from './views/Bubbles';
import data from './config/data';
import moment from 'moment';
import _ from 'lodash';
import LegendOn from './images/legend_button_off.svg';
import {
  BrowserRouter as Router,
  Route,
  NavLink
} from 'react-router-dom'

class App extends Component {

	constructor (props) {
		super(props);
		this.picea = new Picea();
		this.load = props.load;

		let status = this.getStatus(props.now, props.load);

	  	let pulses = {};

	  	for(let [flow,value] of Object.entries(status.flows)) {
	  		if (! value) continue;
	  		flow = flow.replace('el', 'hy');
	  		flow = flow.replace('fc', 'hy');
	  		let [from,to] = flow.split('-');
	  		pulses[from] = 'shrink';
	  		pulses[to] = 'grow';
	  	};
	  	status.pulses = pulses;

		this.state = {
			now: props.now,
			load: props.load,
			status: status,
			info: {
				description: status.description,
				title: status.title
			},
			showLegend: false
		}

		// Bind methods
		this.setDate = this.setDate.bind(this);
		this.setLoad = this.setLoad.bind(this);
		this.getStatus = this.getStatus.bind(this);
		this.toggleInfo = this.toggleInfo.bind(this);
		this.switchLegend = this.switchLegend.bind(this);
	}

	setLoad(newLoad) {
		let newStatus = this.getStatus(this.state.now, newLoad);

	  	let pulses = {};

	  	for(let [flow,value] of Object.entries(newStatus.flows)) {
	  		if (! value) continue;
	  		flow = flow.replace('el', 'hy');
	  		flow = flow.replace('fc', 'hy');
	  		let [from,to] = flow.split('-');
	  		pulses[from] = 'shrink';
	  		pulses[to] = 'grow';
	  	};

	  	newStatus.pulses = pulses;
		this.setState({
			load: newLoad,
			status: newStatus,
			info: {
				title: newStatus.title,
				description: newStatus.description
			}
		})

		return this;
	}

	setDate(newDate) {
		let newStatus = this.getStatus(newDate, this.state.load);

	  	let pulses = {};

	  	for(let [flow,value] of Object.entries(newStatus.flows)) {
	  		if (! value) continue;
	  		flow = flow.replace('el', 'hy');
	  		flow = flow.replace('fc', 'hy');
	  		let [from,to] = flow.split('-');
	  		pulses[from] = 'shrink';
	  		pulses[to] = 'grow';
	  	};

	  	newStatus.pulses = pulses;

		this.setState({
			now: newDate,
			status: newStatus,
			info: {
				description: newStatus.description,
				title: newStatus.title
			}
		})
		return this;
	}

	getStatus(now, load) {
		let id = moment(now).format('YYYY-MM-DD HH:mm');
		let status = data.loads[load].points[id];
		return status;
	}

	toggleInfo(unit, color='#fff') {

		var compiled = _.template(unit.description);
		let description = compiled({ 'status': this.state.status, 'unit': unit});

		this.setState({
			info: {
				title: unit.headline,
				description: description,
				color: color,
				type: unit.id
			},
			infoOpen: true
		})
		return this;
	}

	switchLegend() {
		this.setState({
			showLegend: !this.state.showLegend
		})
	}


  render() {
    return (
    	<div id="surface" style={SurfaceStyle}>
	    	<header style={HeaderStyle}>
	    		<Menu setDateHandler={this.setDate} setLoadHandler={this.setLoad} now={this.state.now} load={this.state.load} />
	    	</header>
	    	<Router>
	    	<div>
	    		<Route path="/" exact={true} render={() => 
			    	<article>
			    		<div style={InfoboxStyle}>
			    			<Infobox ref="infoBox" open={this.state.infoOpen} info={this.state.info} />
			    			<LegendOn width='120px' height='120px' style={LegendStyle} onClick={this.switchLegend} />
			    		</div>
			    		<div style={SVGStyle}>
				    		<Bubbles 
				    			status={this.state.status} 
				    			units={this.picea.units} 
				    			flows={this.picea.flows}
				    			width={1200}
				    			height={1200}
				    			toggleInfoHandler={this.toggleInfo}
				    			showLegend={this.state.showLegend}
				    		/>
		    			</div>
			    	</article>
			    }/>	
	    		<Route path="/Archiv" render={() => 
	    			<div>
				        <img src={'/images/Archiv.png'} style={{position:'absolute', top:0, left: 0}}/>
        			</div>
			    }/>	
	    		<Route path="/Einstellungen" render={() => 
	    			<div>
				        <img src={'/images/Einstellungen.png'} style={{position:'absolute', top:0, left: 0}}/>
        			</div>
			    }/>	
	    		<div style={NavigationStyle}>			
					<NavLink exact={true} style={LinkStyle} activeStyle={LinkActiveStyle} to="/Archiv">Archiv</NavLink>
					<NavLink exact={true} style={LinkStyle} activeStyle={LinkActiveStyle} to="/">Live</NavLink>
					<NavLink exact={true} style={LinkStyle} activeStyle={LinkActiveStyle} to="/Einstellungen">Einstellungen</NavLink>
				</div>
	    	</div>
	    	</Router>
    	</div>
    )
  }
}

App.defaultProps = {
	now: new Date("2017/01/15 00:00"),
	load: 0
}

const SurfaceStyle = {
	height: '1536px',
	width: '2048px',
	backgroundColor: 'white',
	position: 'relative'
};

const LegendStyle = {
	position: 'absolute',
	bottom: 0,
	cursor: 'pointer',
	margin: '40px',
	WebkitTapHighlightColor: 'rgba(0,0,0,0)'
}

const NavigationStyle = {
	position: 'absolute',
	bottom: 0,
	display: 'block',
	width: '100%'
}

const HeaderStyle = {	
	height: '200px'
};

const SVGStyle = {
	width: '1200px',
	height: '1200px',
	float: 'left'
};

const InfoboxStyle = {
	position: 'relative',
	width: '700px',
	height: '1200px',
	float: 'left'
};

const ContainerStyle = {
	width: '100%'
}

const LinkStyle = {
	display: 'inline-block',
	width: '33%',
	padding: '30px 0',
	textAlign: 'center',
	borderWidth: '0 3px',
	borderStyle: 'solid',
	borderColor: 'white',
	backgroundColor: '#ccc',
	font: 'normal normal normal 40px Arial, Helvetica, sans-serif',	
	textDecoration: 'none',
	color: '#555',
	WebkitTapHighlightColor: 'rgba(0,0,0,0)'
}

const LinkActiveStyle = {
	display: 'inline-block',
	width: '33%',
	padding: '30px 0',
	textAlign: 'center',
	borderWidth: '0 3px',
	borderStyle: 'solid',
	borderColor: 'white',
	backgroundColor: '#fff',
	font: 'normal normal normal 40px Arial, Helvetica, sans-serif',	
	textDecoration: 'none',
	color: '#034C8C',
	WebkitTapHighlightColor: 'rgba(0,0,0,0)'
}



export default App;



// WEBPACK FOOTER //
// ./src/App.jsx